
import Title from '~/components/common/page-title.vue'

export default {
  name: 'ContactKv',
  components: {
    Title
  }
}
